require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./tapd-in-super-bowl-2019-wins.json") })
        }
      }, "path---tapd-in-super-bowl-2019-wins");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---tapd-in-super-bowl-2019-wins!./.cache/json/tapd-in-super-bowl-2019-wins.json
// module id = 866
// module chunks = 231608221292675